import {
  i
} from "./chunk.775UL347.js";

// src/components/jb-social-icons/jb-social-icons.css.ts
var jb_social_icons_css_default = i`.sr-only{block-size:1px;border:0;clip:rect(0, 0, 0, 0);inline-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute}ul{align-items:center;display:flex;flex-wrap:nowrap;gap:var(--social-icons-gap, var(--theme-spacing-xs));justify-content:center}@media(min-width: 1281px){ul{gap:var(--social-icons-gap, var(--theme-spacing-sm))}}ul li{list-style:none}ul li jb-anchor{align-items:center;display:flex;justify-content:center;scale:1;transition:scale .3s ease-in-out}ul li jb-anchor::part(anchor){box-sizing:content-box;height:24px}ul li jb-anchor:hover{scale:1.2}ul.start,ul.left{justify-content:start}ul.right,ul.end{justify-content:end}`;

export {
  jb_social_icons_css_default
};
